var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHero3 = function SvgHero3(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 321.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient",
    cx: -124.1441,
    cy: 4.3407,
    r: 467.5275,
    gradientTransform: "translate(4.8098 5.5) scale(0.9679 0.9657)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55bdc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1653,
    stopColor: "#58b8c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3705,
    stopColor: "#5fa8bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    stopColor: "#6b8fb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8362,
    stopColor: "#7c6ca6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a509b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-2",
    cx: 134.6303,
    cy: 39.3626,
    r: 159.4441,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-3",
    cx: 169.6374,
    cy: 90.4505,
    r: 141.3233,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-4",
    cx: 85.5312,
    cy: 44.5338,
    r: 135.8014,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-5",
    cx: -0.7253,
    cy: 34.0997,
    r: 150.0409,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-6",
    cx: 86.8242,
    cy: 44.5604,
    r: 110.8524,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-7",
    cx: 55.1758,
    cy: 70.1429,
    r: 95.8963,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#hero_3_svg__radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-8",
    cx: -23.0934,
    cy: 169.9069,
    r: 190.8256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3adbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2444,
    stopColor: "#a3aac1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#a3a2cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7415,
    stopColor: "#a294e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9906,
    stopColor: "#a280fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a27fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-9",
    cx: 75.6097,
    cy: 364.4182,
    r: 223.2486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#5d47c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#6653c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#7668cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8b84da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9794e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-10",
    cx: 115.0649,
    cy: -6.2118,
    r: 192.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f85aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2373,
    stopColor: "#8085ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4778,
    stopColor: "#8284ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7198,
    stopColor: "#8682cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9615,
    stopColor: "#8b7feb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c7ff0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-11",
    cx: 246.63,
    cy: 267.3594,
    r: 353.9698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b53c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2463,
    stopColor: "#7d57c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#8363cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473,
    stopColor: "#8e78d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#9c94e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-12",
    cx: 268.0738,
    cy: 227.6384,
    r: 172.5504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c49c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    stopColor: "#6f4dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#7659c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    stopColor: "#836ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#958adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-13",
    cx: -193.8687,
    cy: 121.9871,
    r: 261.8274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dc6bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    stopColor: "#51c4be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#5dbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6687,
    stopColor: "#72b6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8932,
    stopColor: "#8eaac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ea3c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-14",
    cx: 175.2484,
    cy: 267.4176,
    r: 180.1517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#787dd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2784,
    stopColor: "#7b81d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#858dd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8437,
    stopColor: "#95a1cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b0c9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-15",
    cx: 177.6064,
    cy: 319.6476,
    r: 111.6542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a49c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2292,
    stopColor: "#5e4dc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#6859c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    stopColor: "#7a6ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9286,
    stopColor: "#938adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c94e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_3_svg__radial-gradient-16",
    cx: -142.723,
    cy: 34.3903,
    r: 376.8674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55bdc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1897,
    stopColor: "#57b9c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#5dadbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5756,
    stopColor: "#6798b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7701,
    stopColor: "#757cac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9636,
    stopColor: "#86589e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a509b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "hero_3_svg__hero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_3_svg__lower-2",
    "data-name": "lower"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_3_svg__bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5631,34.472,5,84.69,32.1022,193.8178q28.5369,34.5978,58.0761,69.5327,22.3061,26.3741,44.525,52.1495,39.6853-43.458,79.3706-86.9159,15.0031-34.2836,30.006-68.567L295,14.3145,190.8435,5.5Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_3_svg__shapes_shard_01"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193,0q.5,10,1,20,7,35.5,14,71l6,17,78-87,8-12Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,29l5,8,52,53L190,7l3-7Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,0,133,88l81,20Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,29,0,83l97,61q-.5-11-1-22L78,34Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,88l81,20L97,144l3-8,24-39Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,29l57,59L97,144q-7-21-14-42Q79.5,65.5,76,29Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,195H28L133.5,321.5l.5-9.5-9-81Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5,142.5,98,147l22,82,4,5,88-2,4-1q1-3.5,2-7,5-28,10-56L106,143Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,106l2,4q5.5,29,11,58l-.5,2.5L98.5146,142.5807Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,160h-1l-18,8-2.5,2.5q-4.75,30.25-9.5,60.5Q231.5,195.5,247,160Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,106q6.25,32.25,12.5,64.5L247,160Q273.5,84.5,300,9Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,83l98.5,59.5L91,151,33,193l-5,2Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,232.5,28,195l70.5-52.5Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5,232.5q5.5,44.5,11,89L216,231Z",
    style: {
      fill: "url(#hero_3_svg__radial-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,83l98.5,59.5L213,106,300,9,193,0,76,29Z",
    style: {
      opacity: 0.88,
      fill: "url(#hero_3_svg__radial-gradient-16)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_3_svg__highlights-5",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224,169q-4-23-8-46l10,46,17-7-17,9-6,37q2-18.5,4-37l-44-10Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,152l12,41,45-32L31,195l47,20L31,197q29.313,35.7359,29,36-.3233.27-32-37Q22.5,174,17,152Z",
    style: {
      fill: "#f2f2f2"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHero3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hero_3.7bde968367e60bc3b26d6a7b99ed970f.svg";